import { computed, type Ref } from "vue";

export function useStaticImage(image: Ref<string | undefined>) {
  const imageUrl = computed(() =>
    image.value ? `/static/image/${image.value}` : ""
  );

  return { imageUrl };
}
